import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import notificationReducer from "./notificationSlice";
import mealReducer from "./mealSlice";
import generalSettingsReducer from "./generalSettingsSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    notification: notificationReducer,
    meal: mealReducer,
    generalSettings: generalSettingsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
